<template>
  <div>
    <ask
      ref="askToRemove"
      title="Cancel Payment Request"
      @ok="remove"
      message="Are you sure you would like to cancel this payment request?"
    ></ask>

    <b-row class="m-0">
      <b-col class="modal-hero">
        <b-card class="p-0 m-0 shadow-none">
          <b-row>
            <b-col
              class="pr-0 panel-divider panel-first"
              v-if="notification.eMail"
            >
              <div class="card-panel">
                <div class="stat-box-title">Email</div>
                <div class="stat-box-body">
                  {{ notification.eMail }}
                </div>
              </div>
            </b-col>
            <b-col
              class="pr-0"
              v-bind:class="{ 'pl-0 panel-divider': notification.eMail }"
              v-if="notification.toPhone"
            >
              <div class="card-panel">
                <div class="stat-box-title">Mobile Phone</div>
                <div class="stat-box-body">
                  {{ notification.toPhone | phonenumber }}
                </div>
              </div>
            </b-col>
            <b-col class="pl-0 pr-0 panel-divider" v-if="notification.resent">
              <div class="card-panel">
                <div class="stat-box-title">Last Reminder Sent</div>
                <div class="stat-box-body" v-if="notification.resent">
                  <b>{{ notification.resent | moment("MM/DD/YYYY") }}</b>
                </div>
                <div class="stat-box-body">
                  <a href="#" id="tooltip-target-1"
                    ><small><strong>Reminder History</strong></small></a
                  >
                  <b-tooltip target="tooltip-target-1" triggers="hover">
                    <b-row>
                      <b-col class="text-left">
                        <small><strong>Date</strong></small>
                      </b-col>
                      <b-col class="text-left">
                        <small><strong>Time</strong></small>
                      </b-col>
                    </b-row>
                    <b-row v-for="resent in notification.notificationsResent">
                      <b-col>
                        <small>{{
                          resent.dateTime | moment("MM/DD/YYYY")
                        }}</small>
                      </b-col>
                      <b-col>
                        <small class="text-nowrap">
                          {{ resent.dateTime | moment("hh:mm:ss A") }}
                        </small>
                      </b-col>
                    </b-row>
                  </b-tooltip>
                </div>
              </div>
            </b-col>

            <b-col class="pl-0 panel-divider text-nowrap">
              <div class="card-panel">
                <div class="stat-box-title">
                  Amount <span v-if="!notification.paid">Requested</span
                  ><span v-if="notification.paid">Paid</span>
                </div>
                <div class="stat-box-body">
                  {{ (notification.amount / 100) | currency }}<br />
                  <div v-if="hasRole('EDITPAYMENTREQUESTS')">
                    <a
                      href
                      @click.prevent="remind"
                      class="mr-3"
                      v-if="!notification.paid"
                      ><small
                        ><i class="pr-1 fa-solid fa-bell-on"></i
                        ><strong>Send Reminder</strong></small
                      ></a
                    ><a
                      @click.prevent="copyLink"
                      class="mr-3"
                      href="#"
                      v-if="!notification.paid"
                      ><small
                        ><i class="pr-1 fa-solid fa-clipboard"></i
                        ><strong>Copy Link</strong></small
                      ></a
                    >
                    <a
                      @click="$refs.askToRemove.ask()"
                      href="#"
                      v-if="!notification.paid"
                      class="request-cancel"
                      ><small
                        ><i class="pr-1 fa-solid fa-trash-can-xmark"></i
                        ><strong>Cancel</strong></small
                      ></a
                    >
                  </div>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="m-0">
      <b-col class="body-modal">
        <b-row>
          <b-col class="text-center p-0 ml-3">
            <span class="request-title"
              >Sent to
              <span v-if="notification.eMail">Email</span>
              <span v-if="notification.eMail && notification.toPhone"> & </span>
              <span v-if="notification.toPhone">Mobile</span>
            </span>
            <div class="request-frame">
              <span v-if="notification.eMail && !notification.toPhone"
                ><i
                  class="request-icon fa-solid fa-circle-envelope request-icon-active"
                ></i
              ></span>
              <span v-else-if="notification.eMail && notification.toPhone"
                ><i
                  class="request-icon fa-solid fa-circle-envelope request-icon-active"
                ></i
                ><i
                  class="request-icon fa-solid fa-circle-phone request-icon-active"
                ></i
              ></span>
              <span v-else-if="!notification.eMail && notification.toPhone"
                ><i
                  class="request-icon fa-solid fa-circle-phone request-icon-active"
                ></i
              ></span>
            </div>
            <div class="bar bar-left bar-active"></div>
            <span class="request-stamp">
              <b>{{ notification.created | moment("MM/DD/YYYY") }}</b>
              <div class="mt--1">
                <small>{{ notification.created | moment("hh:mm:ss A") }}</small>
              </div>
            </span>
          </b-col>
          <b-col class="text-center p-0">
            <span class="request-title" v-if="notification.paymentPage"
              >Viewed</span
            >
            <span
              class="request-title text-muted"
              v-if="!notification.paymentPage"
              >Viewed</span
            >
            <div class="request-frame">
              <i
                v-if="notification.paymentPage"
                class="request-icon fa-solid fa-circle-user request-icon-active"
              ></i>
              <i
                v-if="!notification.paymentPage"
                class="request-icon fa-solid fa-circle-user"
              ></i>
            </div>
            <div class="bar bar-center">
              <div
                v-if="notification.paymentPage"
                class="bar bar-center bar-active"
              ></div>
            </div>
            <span class="request-stamp" v-if="notification.paymentPage">
              <b>{{ notification.paymentPage | moment("MM/DD/YYYY") }}</b>
              <div class="mt--1">
                <small>{{
                  notification.paymentPage | moment("hh:mm:ss A")
                }}</small>
              </div>
            </span>
          </b-col>
          <b-col class="text-center p-0 mr-3">
            <span class="request-title" v-if="notification.paid">Paid</span>
            <span class="request-title text-muted" v-if="!notification.paid"
              >Paid</span
            >
            <div class="request-frame">
              <i
                v-if="notification.paid"
                class="request-icon fa-solid fa-circle-dollar request-icon-active"
              ></i>
              <i
                v-if="!notification.paid"
                class="request-icon fa-solid fa-circle-dollar"
              ></i>
            </div>
            <div class="bar bar-right">
              <div
                v-if="notification.paid"
                class="bar bar-right bar-active"
              ></div>
            </div>
            <span class="request-stamp" v-if="notification.paid">
              <b> {{ notification.paid | moment("MM/DD/YYYY") }}</b>
              <div class="mt--1">
                <small>{{ notification.paid | moment("hh:mm:ss A") }}</small>
              </div>
            </span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="m-0 p-0 top-divider" v-if="showTransactions">
      <b-col class="body-modal">
        <h3 class="pb-2">Payment Activity</h3>
        <transaction-search-results
          headless="true"
          supressPatientName="true"
          supressSource="true"
          :query="getSearchResultsQuery()"
          @length="checkLengthToHide"
        ></transaction-search-results>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import TransactionSearchResults from "@/views/Components/Transactions/SearchResults.vue";
import CopyLink from "@/views/Components/CopyLink";

export default {
  components: { TransactionSearchResults, "copy-link": CopyLink },

  async created() {
    this.bind();
  },
  inject: ["hasRole"],
  props: { notificationId: null, setName: null },
  data() {
    return {
      notification: null,
      showTransactions: true,
    };
  },
  methods: {
    async bind() {
      var r = await this.$client.get(
        "/api/notification/getnotification?id=" + this.notificationId
      );

      if (r.data.isSuccess) {
        {
          this.notification = r.data.value;
          this.setName(
            this.notification.firstName + " " + this.notification.lastName
          );
        }
      }
    },
    checkLengthToHide(length) {
      if (length > 0) this.showTransactions = true;
      else this.showTransactions = false;
    },
    remind() {
      var self = this;

      self.$client
        .post("/api/notification/remind", { ids: [self.notification.id] })
        .then((r) => {
          if (r.data.isSuccess) {
            let d = new Date();
            self.notification.resent = d;

            self.$set(
              self.notification.notificationsResent,
              self.notification.notificationsResent.length,
              d
            );

            self.$emitter.emit("success", { message: "Reminder Sent" });
            this.bind();
          }
        });
    },
    remove() {
      var self = this;

      self.$client
        .post("/api/notification/remove", { ids: [self.notification.id] })
        .then((r) => {
          if (r.data.isSuccess) {
            self.$emitter.emit("bind-notifications");
            self.$emit("close");
            self.$emitter.emit("success", {
              message: "Payment Request Removed",
            });
          }
        });
    },
    copyLink() {
      var text = this.notification.link;

      navigator.clipboard.writeText(text).then(
        () => {
          this.$emitter.emit("success", { message: "Copied to clipboard" });
        },
        (err) => {
          this.$emitter.emit(
            "no-success",
            "Unable to copy to clipboard " + err.message
          );
        }
      );
    },
    getSearchResultsQuery() {
      var self = this;

      return {
        notificationId: self.notificationId,
        statuses: ["APPROVED", "DECLINED"],
        currentPage: 1,
        modules: ["TEXTTOPAY"],
        sortOption: "Date:descending",
      };
    },
  },
};
</script>

<style scoped>
.notify-icon {
  margin-top: 5px;
  padding-right: 5px;
  display: inline-block;
}
.notify-icon i {
  font-size: 1.4em;
  color: #8898aa;
}

.bar {
  width: 100%;
  height: 10px;
  background: #dee2e6;
  position: relative;
  z-index: 1;
}

.bar.bar-active {
  background: #74e4b4;
}

.bar.bar-left {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.bar.bar-right {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.request-icon {
  font-size: 1.8em;
  color: #dee2e6;
  margin-top: 10px;
  padding: 0 5px;
  position: relative;
}

.request-icon-active {
  color: #2dce89;
}

.request-cancel:hover {
  color: #f5365c;
}

.request-icon:after {
  position: absolute;
  content: "";
  background: #fff;
  z-index: -1;
  top: 5px;
  left: 10px;
  width: 20px;
  height: 20px;
}

.request-frame {
  display: block;
  position: relative;
  margin-bottom: -24px;
  z-index: 2;
}

.request-title {
  font-size: 0.9em;
  font-weight: 700;
}

.request-stamp {
  margin-top: 20px;
  display: block;
  font-size: 0.9em;
}
</style>
